import React, { useEffect } from "react";
import "../styles/About.css";

function About() {
    useEffect(() => {
        // Scroll animation using Intersection Observer
        const aboutSections = document.querySelectorAll(".about-container");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry, index) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            entry.target.classList.add("visible");
                        }, index * 150); // Adds a staggered delay for a cascading effect
                    }
                });
            },
            { threshold: 0.3 }
        );

        aboutSections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);

    return (
        <div className="luxury-about-section">
            <div className="about-container">
                {/* Left Image - Soft Slide-in from Left */}
                <div className="about-image-container soft-slide-left">
                    <img
                        src="/Chai-Espresso-Martini-1.jpg"
                        alt="Gourmet Food Left"
                        className="about-image"
                    />
                </div>

                {/* Content Section - Smooth Fade and Scale */}
                <div className="about-content-container elegant-fade-scale">
                    <h2 className="about-title">Special Moments</h2>
                    <h3 className="about-subtitle">About Us</h3>
                    <p className="about-description">
                        At <span className="highlight">Sol Cafe & Lounge</span>, we combine exquisite culinary delights
                        and signature drinks with an electrifying atmosphere. Savor
                        our delicious food and premium cocktails while enjoying live
                        performances by talented DJs and professional dancers,
                        creating unforgettable memories for every moment.
                    </p>
                    <button className="about-button" onClick={() => window.location.href = "/about"}>Read More</button>
                </div>

                {/* Right Image - Soft Slide-in from Right */}
                <div className="about-image-container soft-slide-right">
                    <img
                        src="/Greek-Style-Lamb-Chops-featsq-1.jpg"
                        alt="Gourmet Food Right"
                        className="about-image"
                    />
                </div>
            </div>
        </div>
    );
}

export default About;
